/**
 * Normalize SPA paths for GA: pathname only, no query/hash, redact token-like segments.
 */
export function sanitizeAnalyticsPagePath(pathname: string): string {
  const base = pathname.split(/[?#]/, 1)[0] || "/";
  const normalized = base.startsWith("/") ? base : `/${base}`;
  const segments = normalized.split("/").filter(Boolean);

  if (segments[0] === "approvals" && segments.length > 1) {
    return "/approvals";
  }
  if (segments[0] === "grant" && segments.length > 1) {
    return "/grant";
  }
  if (segments[0] === "helpers" && segments.length > 1 && segments[1] !== "new") {
    return "/helpers/:id";
  }

  return normalized || "/";
}
